import { Theme, Typography, Box } from '@mui/material';
import { NumberText } from 'quote-detail/number-text';
import { SxProps } from '@mui/material';

interface InfoLabelProps {
  label: string;
  text: string | number;
  displayType?: 'number' | 'text';
  suffix?: string;
  prefix?: string;
  highlight?: boolean;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
}

const labelStyles: SxProps<Theme> = {
  fontWeight: 'bold',
};
const highlightStyles = (highlight: boolean | undefined) => (theme: Theme) => ({
  color: highlight ? theme.palette.secondary.main : 'inherit',
});

export function InfoLabel({
  text,
  label,
  displayType,
  suffix,
  prefix,
  highlight,
  decimalScale = 2,
  fixedDecimalScale,
}: InfoLabelProps) {
  const numberDisplay = (
    <NumberText
      text={text}
      suffix={suffix}
      prefix={prefix}
      variant='subtitle1'
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
    />
  );
  const textDisplay = <Typography variant='subtitle1'>{text}</Typography>;

  return (
    <>
      <Typography sx={labelStyles} variant='caption'>
        {label}
      </Typography>
      <Box sx={highlightStyles(highlight)}>{displayType === 'number' ? numberDisplay : textDisplay}</Box>
    </>
  );
}
